import React, { useEffect, useRef, useState } from "react";
import styles from "./comp_css/chapter_54.module.css";
import { Link } from "@mui/material";
import MembershipModal from "../../../components/Modal/MembershipModal";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter54.json";
import Head from "next/head";

export default function Chapter_54() {
  // const corosalref = useRef()

  // useEffect(() => {
  //   if (corosalref.current) {
  //     corosalref.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "nearest",
  //       inline: "start"
  //     })
  //   }
  //   console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])

  const router = useRouter();
  const location = useRouter();
  const { pathname } = location;

  const [membershipOpen, setMembershipOpen] = useState(false);
  const memberfunc = () => {
    setMembershipOpen(true);
  };

  return (
    <>
      <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Kali-Krishna union, World Soul archetypes, cosmic consciousness, Platonic philosophy, Egyptian myth, holographic string theory."
        ></meta>
        <meta
          property="og:title"
          content="Kali-Krishna and the World Soul: Cosmic Archetypes Unveiled"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="Unveil the cosmic dance of Kali-Krishna, the World Soul, and archetypal forms. Drawing from Plato, Egyptian Goddess Nut, and holographic string theory, this exploration reveals the deep interconnection of consciousness, divine order, and the universe’s living soul. Witness how ancient wisdom mirrors modern science in understanding existence."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=54"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=54"
        ></meta>
        <meta
          name="twitter:title"
          content="Kali-Krishna and the World Soul: Cosmic Archetypes Unveiled"
        ></meta>
        <meta
          name="twitter:description"
          content="Explore the union of Kali and Krishna, the World Soul, and cosmic archetypes. Journey through Platonic philosophy, Egyptian myth, and holographic string theory to uncover the interplay of consciousness, the Singularity, and the divine feminine. Discover the timeless bridge between physics, psychology, and spiritual transformation."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=54" />
      </Head>
      <Common_html BlockData={BlockData} />


    </>
  );
}
